import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Login } from "@gisce/oficina-virtual-components";
import { RootState } from "@/store";
import useCredentials from "./Authentication/hooks/useCredentials";
import { useSettingsContext } from "./Settings/hooks/useSettingsContext";
import ServerElementsWithoutActions from "./ServerElements/components/ServerElementsWithoutActions";
import { Divider } from "@mui/material";

const LoginView: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const { loginCredentials } = useCredentials();
  const { 
    isAuthenticating,
    statusType,
    statusCode
  } = useSelector((state: RootState) => state.auth);
  const loginType = useSelector((state: RootState) => state.auth.type);

  const handleSignUp = () => {
    navigate(t('common:url.activate'));
  };

  const handleReset = () => {
    navigate(t('common:url.resetPassword'));
  };

  const handleLogin = (user: string, password: string) => {
    loginCredentials({user, password});
  };

  const getErrorMessage = () => {
    switch(statusCode) {
      case 401:
        return t('common:text.login_view_message_error_login');
      case 403:
        return t('common:text.login_view_message_error_login');
      
      default: 
        return t('common:text.login_view_message_error_login');
    }
  }

  return (
    <>
      <Login
      alertProps={
        loginType === "credentials" &&
        statusType === "error" ? 
        {
          severity: "error", 
          label: getErrorMessage()
        } 
        : undefined
      }
      signUp={Settings?.features?.signup}
      onLogin={handleLogin}
      onSignUp={handleSignUp}
      onReset={handleReset}
      loading={isAuthenticating}
    />
    <Divider sx={{mb: 3}}/>
Las facturas posteriores al 15 de abril de 2026 puedes consultarlas en la nueva <a href="https://oficinavirtual.elyges.com/" target="_blank">Oficina Virtual</a>.
    </>
  );
};

export default LoginView;
